module.exports = __webpack_public_path__ + "img/jgyl.0a32e508.png";